<template>
  <div>
    <div class="wrap message-list-wrap">
      <div class="top-header">
        <h3>나의 코칭</h3>
      </div>
      <div class="body-wrap">
        <incMenu></incMenu>
        <div class="message-list">
          <!-- <div class="message" @click="messageView()" v-for="(item,index) in list" :key="index">
                        <img :src="item.coarPic" alt="" style="max-width:49px;">
                        <p>{{item.coarchName}} 코치님과의 대화 <span>20</span></p>
                    </div> -->
          <div class="message" @click="messageView(item.coachIdx)" v-for="(item, index) in chat_list" :key="index">
            <img :src="item.coachProfileImage" alt="" style="max-width: 49px; padding-right: 5px;" />
            <p>{{ item.coachName }} 코치님과의 대화</p>
            <p>
              <span v-if="item.unreadCount > 0">{{ item.unreadCount }}</span>
            </p>
          </div>
          <div class="message" @click="messageView(-1)">
            <img src="@/assets/img/bnb-icon.svg" alt="" style="padding-right: 5px;" />
            <p>
              코칭센터 1:1 문의 <span>{{ unreadReplyCount }}</span>
            </p>
          </div>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incMenu from "@/components/inc/inc_menu.vue";
import incTab from "@/components/inc/inc_tab.vue";
export default {
  name: "coaching_message",
  data: () => ({
    chat_list: [],
    unreadReplyCount: 0,
  }),
  components: {
    incTab,
    incMenu,
  },
  mounted() {
    this.getChatList();
    this.getQnaCount();
    setInterval(() => {
      this.getChatList();
      this.getQnaCount();
    }, 1000);
  },
  methods: {
    getQnaCount() {
      this.axios
        .get(`/qna/count/${this.$store.state.userInfo.userIdx}`)
        .then((res) => {
          if (res.data.success) {
            this.unreadReplyCount = res.data.contentinfo.unreadReplyCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getChatList() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/chat/list", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.chat_list = res.data.contentinfo.chatList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    messageView(coarchIdx) {
      this.$router.push({ name: "message", params: { coarchIdx: coarchIdx } });
    },
  },
};
</script>
